import { DatePicker as MuiDatePicker, type DatePickerProps as MuiDatePickerProps } from '@mui/x-date-pickers/DatePicker';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';
import { type PickerFieldProps, pickerFieldSlotProps } from '../../../utils/pickerFieldSlotProps';

type Props = WithoutStyleOverrides<Omit<MuiDatePickerProps, 'slots'>> & PickerFieldProps;

export function DatePicker(props: Props) {
  const { helperText, error, required, size, fullWidth, slotProps, ...datePickerProps } = props;

  return (
    <MuiDatePicker
      {...datePickerProps}
      slotProps={{
        ...slotProps,
        textField: pickerFieldSlotProps(slotProps?.textField, { helperText, error, required, size, fullWidth }),
      }}
    />
  );
}

export type { Props as DatePickerProps };
